import { GTTripV2Status } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const statusMessages = defineMessages({
  [GTTripV2Status.OnTime]: {
    id: 'dictionary.onTime',
    defaultMessage: 'On time'
  },
  [GTTripV2Status.Completed]: {
    id: 'dictionary.completed',
    defaultMessage: 'Completed'
  },
  [GTTripV2Status.InTransit]: {
    id: 'dictionary.inTransit',
    defaultMessage: 'In transit'
  },
  [GTTripV2Status.Cancelled]: {
    id: 'dictionary.cancelled',
    defaultMessage: 'Cancelled'
  }
})
